var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ColumnBaseComponent } from '../base/columnbase.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
var OneCheckboxComponent = /** @class */ (function (_super) {
    __extends(OneCheckboxComponent, _super);
    function OneCheckboxComponent(service, baseService) {
        var _this = _super.call(this, service, baseService) || this;
        _this.service = service;
        _this.baseService = baseService;
        return _this;
    }
    OneCheckboxComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    OneCheckboxComponent.prototype.onChange = function (e) {
        _super.prototype.onChange.call(this, e.target.checked ? true : null);
    };
    OneCheckboxComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-one-checkbox',
                    template: "<input type=\"checkbox\" id=\"{{ colKey }}\" name=\"{{ colKey }}\" [checked]=\"val\" (change)=\"onChange($event)\" [key]=\"key\" [col]=\"col\" columnDir>\n<label for=\"{{ colKey }}\" [key]=\"key\" [col]=\"col\" columnDir>{{ col.params?.display }}</label>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    OneCheckboxComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService }
    ]; };
    return OneCheckboxComponent;
}(ColumnBaseComponent));
export { OneCheckboxComponent };
//# sourceMappingURL=one-checkbox.component.js.map